import axios from 'axios'
import store from '../redux/store'
import {
  API_ADD_PAYMENT_CARD_CUSTOMER,
  API_ADD_PROMOTION,
  API_CHANGE_ORDER_TYPE,
  API_CREATE_CUSTOMER,
  API_DELETE_CARD_CUSTOMER,
  API_DELETE_CUSTOMER_ACCOUNT,
  API_GET_CUSTOMER,
  API_UPDATE_PAYMENT_CARD_CUSTOMER,
  API_USER,
  WEBAPP
} from '../constants'
import { getFirebaseCustomerId, getIdToken } from './firebase/firebaseAuthentication'
import { sendCloudWatchAlert } from '../utils/logs'

export const initializeBackend = domain => {
  // domain = 'https://dev-backend.dishop.co.ngrok.dev';
  // domain = 'http://localhost:3000'
  axios.defaults.baseURL = String(domain);
  return true;
};

export const sendPostRequest = async (url, data, headers) => {
  try {
    const { companyId } = store.getState().configurationReducer;
    const newData = { ...data, companyId };
    return await axios({
      method: 'post',
      url,
      data: newData,
      headers
    });
  } catch (error) {
    throw error.response ? error.response.data.errorMessage : error;
  }
};

export const sendGetRequest = async (url, data, headers, addCompanyIdParams = true) => {
  try {
    let newData = data
    if (addCompanyIdParams) {
      const { companyId } = store.getState().configurationReducer;
      newData = { ...data, companyId };
    }
    return await axios({
      method: 'get',
      url,
      params: newData,
      headers
    });
  } catch (error) {
    throw error.response ? error.response.data.errorMessage : error;
  }
};

export const sendPutRequest = async (url, data, headers) => {
  try {
    return await axios.put(url, data, { headers });
  } catch (error) {
    throw error.response ? error.response.data.errorMessage : error;
  }
};

export const addPromotionBackend = async (customerId, promoCode, deviceId) => {
  const idToken = await getIdToken();
  const headers = { Authorization: `Bearer ${idToken}` };
  const { shopId } = store.getState().pendingOrderReducer;
  const data = {
    customerId,
    promoCode,
    deviceId,
    shopId,
    canal: WEBAPP
  };
  return await sendPostRequest(API_ADD_PROMOTION, data, headers);
};

export const createCustomerBackend = async customerProfile => {
  const { shopId } = store.getState().shopReducer;
  const data = {
    customerProfile,
    shopId
  };
  const customerId = getFirebaseCustomerId();
  let headers = {};
  if (customerId) {
    const idToken = await getIdToken();
    headers = { Authorization: `Bearer ${idToken}` };
  }
  return await sendPostRequest(API_CREATE_CUSTOMER, data, headers);
};

export const getCustomerBackend = async () => {
  try {
    const customerId = getFirebaseCustomerId();
    if (customerId) {
      const data = {
        customerId
      };
      const idToken = await getIdToken();
      const headers = { Authorization: `Bearer ${idToken}` };
      const response = await sendGetRequest(API_GET_CUSTOMER, data, headers);
      return response.data;
    }
  } catch (error) {
    sendCloudWatchAlert(`Could not get customer backend ${error}`);
  }
};

export const updateCustomerPaymentCardBackend = async newCardId => {
  const { user } = store.getState().userReducer;
  const data = {
    newCardId,
    customerId: user.customerId
  };
  const idToken = await getIdToken();
  const headers = { Authorization: `Bearer ${idToken}` };
  await sendPostRequest(API_UPDATE_PAYMENT_CARD_CUSTOMER, data, headers);
};

export const addCustomerPaymentCardBackend = async newCard => {
  const { user } = store.getState().userReducer;
  const data = {
    newCard,
    customerId: user.customerId
  };
  const idToken = await getIdToken();
  const headers = { Authorization: `Bearer ${idToken}` };
  await sendPostRequest(API_ADD_PAYMENT_CARD_CUSTOMER, data, headers);
};

export const deleteCustomerPaymentCardBackend = async cardId => {
  const { user } = store.getState().userReducer;
  const data = {
    cardId,
    customerId: user.customerId
  };
  const idToken = await getIdToken();
  const headers = { Authorization: `Bearer ${idToken}` };
  await sendPostRequest(API_DELETE_CARD_CUSTOMER, data, headers);
};

export const deleteCustomerAccountBackend = async () => {
  const customerId = getFirebaseCustomerId();
  if (customerId) {
    sendCloudWatchAlert(`Delete user ${customerId}`);
    const { shopId } = store.getState().shopReducer;
    const data = {
      customerId,
      shopId
    };
    const idToken = await getIdToken();
    const headers = { Authorization: `Bearer ${idToken}` };
    await sendPostRequest(API_DELETE_CUSTOMER_ACCOUNT, data, headers);
  }
};

export const updateUser = async (
  userId,
  updatedUserData
) => {
  const { companyId } = store.getState().configurationReducer;
  try {
    const idToken = await getIdToken();
    const headers = { Authorization: `Bearer ${idToken}` };
    const url = API_USER(companyId, userId)
    const response = await sendPutRequest(url, updatedUserData, headers);
    return response.data;
  } catch (error) {
    sendCloudWatchAlert(`Could not update user ${userId} of company ${companyId} ${error}`);
    throw error
  }
};
export const changeOrderTypeEndpoint = async (
  order,
  newOrderType
) => {
  const { companyId } = store.getState().configurationReducer;
  try {
    const idToken = await getIdToken();
    const data = { nature: newOrderType }
    const headers = { Authorization: `Bearer ${idToken}` };
    const url = API_CHANGE_ORDER_TYPE(companyId, order.id, order.chargeId)
    const response = await sendPutRequest(url, data, headers);
    return response.data;
  } catch (error) {
    sendCloudWatchAlert(`Could not changer order type from ${order.orderType} to ${newOrderType} of company ${companyId} ${error}`);
    throw error
  }
};
